var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenthick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89 13.57L7.38875 11.0687C7.17792 10.8579 6.91917 10.7525 6.6125 10.7525C6.30583 10.7525 6.0375 10.8675 5.8075 11.0975C5.59667 11.3083 5.49125 11.5767 5.49125 11.9025C5.49125 12.2283 5.59667 12.4967 5.8075 12.7075L9.085 15.985C9.29583 16.1958 9.56417 16.3012 9.89 16.3012C10.2158 16.3012 10.4842 16.1958 10.695 15.985L17.2213 9.45875C17.4321 9.24792 17.5375 8.98917 17.5375 8.6825C17.5375 8.37583 17.4225 8.1075 17.1925 7.8775C16.9817 7.66667 16.7133 7.56125 16.3875 7.56125C16.0617 7.56125 15.7933 7.66667 15.5825 7.8775L9.89 13.57ZM11.5 23C9.90917 23 8.41417 22.6979 7.015 22.0938C5.61583 21.4904 4.39875 20.6712 3.36375 19.6362C2.32875 18.6012 1.50957 17.3842 0.9062 15.985C0.302067 14.5858 0 13.0908 0 11.5C0 9.90917 0.302067 8.41417 0.9062 7.015C1.50957 5.61583 2.32875 4.39875 3.36375 3.36375C4.39875 2.32875 5.61583 1.50918 7.015 0.90505C8.41417 0.301683 9.90917 0 11.5 0C13.0908 0 14.5858 0.301683 15.985 0.90505C17.3842 1.50918 18.6012 2.32875 19.6362 3.36375C20.6712 4.39875 21.4904 5.61583 22.0938 7.015C22.6979 8.41417 23 9.90917 23 11.5C23 13.0908 22.6979 14.5858 22.0938 15.985C21.4904 17.3842 20.6712 18.6012 19.6362 19.6362C18.6012 20.6712 17.3842 21.4904 15.985 22.0938C14.5858 22.6979 13.0908 23 11.5 23Z",
    fill: "#00A86B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenthick);
export default __webpack_public_path__ + "static/media/green thick.00fc48fe364a7e59db3cc2eb72f43ff1.svg";
export { ForwardRef as ReactComponent };